import { render, staticRenderFns } from "./BgRelationModalView.vue?vue&type=template&id=c3b7719c"
import script from "./BgRelationModalView.vue?vue&type=script&lang=js"
export * from "./BgRelationModalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports